import { SimpleTitle } from '../styles';
import { FC } from 'react';

export const NotificationCertificate: FC<{item: any}> = ({ item }) => {
    const { actions } = item;

    let finalDescription = actions?.[0]?.description;

    actions?.[0]?.textParts?.forEach((part: any) => {
        const text = part.parts[0];
        const link = part.link;
        if (text && link) {
            const anchorTag = `<a href="${link}" target="_blank" rel="noopener noreferrer">${text}</a>`;
            finalDescription = finalDescription.replace(text, anchorTag);
        }
    });

    return (
        <SimpleTitle>
            <div dangerouslySetInnerHTML={{ __html: finalDescription }} />
        </SimpleTitle>
    );
};
import { SimpleTitle } from '../styles';
import { FC } from 'react';

export const NotificationCertificate: FC<{item: any}> = ({ item }) => {
    const { actions } = item;

    let finalDescription = actions?.[0]?.description;

    actions?.[0]?.textParts?.forEach((part: any) => {
        const text = part.parts[0];
        const link = part.link;
        if (text && link) {
            const anchorTag = `<a href="${link}" target="_blank" rel="noopener noreferrer">${text}</a>`;
            finalDescription = finalDescription.replace(text, anchorTag);
        }
    });

    return (
        <SimpleTitle>
            <div dangerouslySetInnerHTML={{ __html: finalDescription }} />
        </SimpleTitle>
    );
};
